import { render } from "./FileIcons.vue?vue&type=template&id=3471f1a8&scoped=true"
import script from "./FileIcons.vue?vue&type=script&lang=js"
export * from "./FileIcons.vue?vue&type=script&lang=js"

import "./FileIcons.vue?vue&type=style&index=0&id=3471f1a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3471f1a8"]])

export default __exports__